import { createSlice } from '@reduxjs/toolkit'
import { gameClose, userLogin } from 'redux-store/thunk/auth.thunk'
import { fetchUserInformation } from 'redux-store/thunk/user.thunk'
import { getPayloadFromToken } from 'utils/common-functions/index'
import { CURRENCY_SYMBOLS } from 'utils/constants/index'
import { plus, minus } from 'number-precision'

const defaultAuthState = {
  creditWalletWaitQueue: [],
  creditDemoWalletWaitQueue: [],
  userInfo: null,
  userDetails: null,
  currencyId: null,
  currencyCode: null,
  currencySymbol: null,
  isLoggedIn: false,
  showName: false,
  serverSeedHashes: null
}

const authSlice = createSlice({
  name: 'authSlice',
  initialState: defaultAuthState,
  reducers: {
    appendCreditWalletWaitQueue: (state, action) => {
      return {
        ...state,
        creditWalletWaitQueue: [action.payload, ...state.creditWalletWaitQueue]
      }
    },
    updateCreditWalletWaitQueue: (state, action) => {
      const { currentBetWinningAmount } = action.payload
      let _creditWalletWaitQueue = [...state.creditWalletWaitQueue]
      const { balance: currentBalance } = { ...state.userInfo.wallet }
      const _userInfoWallet = { ...state.userInfo.wallet, balance: plus(currentBalance, +currentBetWinningAmount) }

      // const _userInfoWallet = _creditWalletWaitQueue[_creditWalletWaitQueue.length - 1] ?? state.userInfo.wallet
      _creditWalletWaitQueue = _creditWalletWaitQueue?.slice(0, _creditWalletWaitQueue.length - 1)
      return {
        ...state,
        creditWalletWaitQueue: _creditWalletWaitQueue,
        userInfo: {
          ...state.userInfo,
          wallet: _userInfoWallet
        }
      }
    },
    updateCreditDemoWalletWaitQueue: (state, action) => {
      let _creditDemoWalletWaitQueue = [...state.creditDemoWalletWaitQueue]
      const _newDemoWallet = _creditDemoWalletWaitQueue.pop() ?? state.demoWallet
      _creditDemoWalletWaitQueue = _creditDemoWalletWaitQueue?.slice(0, _creditDemoWalletWaitQueue.length - 1)
      return {
        ...state,
        creditDemoWalletWaitQueue: _creditDemoWalletWaitQueue,
        demoWallet: _newDemoWallet
      }
    },
    appendCreditDemoWalletWaitQueue: (state, action) => {
      return {
        ...state,
        creditDemoWalletWaitQueue: [action.payload, ...state.creditDemoWalletWaitQueue]
      }
    },
    setShowName: (state, action) => {
      return {
        ...state,
        showName: !state.showName
      }
    },
    setUserInfo: (state, action) => ({
      ...state,
      userInfo: {
        ...state.userInfo,
        wallet: action.payload
      }
    }),
    updateUserWallet: (state, action) => ({
      ...state,
      userInfo: {
        ...state.userInfo,
        wallet: action.payload
      }
    }),
    debitBalance: (state, action) => {
      const { balance: currentBalance } = { ...state.userInfo.wallet }
      const _userInfoWallet = { ...state.userInfo.wallet, balance: minus(currentBalance, +action?.payload) }
      return ({
        ...state,
        userInfo: {
          ...state.userInfo,
          wallet: _userInfoWallet
        }
      })
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.fulfilled, (state, action) => {
        const { user, wallet, accessToken } = action.payload
        const payload = getPayloadFromToken(accessToken)
        const currencyId = payload?.currencyId
        const currencyCode = payload?.currencyCode
        const currencySymbol = CURRENCY_SYMBOLS?.[currencyCode] || '$'
        const operatorId = payload?.operatorId
        return {
          ...state,
          currencyId,
          currencyCode,
          currencySymbol,
          operatorId,
          userInfo: { user, wallet },
          isLoggedIn: true
        }
      })
      .addCase(fetchUserInformation.fulfilled, (state, action) => {
        return {
          ...state,
          userDetails: action.payload,
          serverSeedHashes: action.payload.serverSeedHash
        }
      })
      .addCase(gameClose.fulfilled, (state, action) => {
        return defaultAuthState
      })
  }
})

export const { setUserInfo, appendCreditWalletWaitQueue, appendCreditDemoWalletWaitQueue, updateCreditDemoWalletWaitQueue, updateCreditWalletWaitQueue, setShowName, updateUserWallet, debitBalance } = authSlice.actions

export default authSlice.reducer
